
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ClozeTestComponent, ClozeTestModel, ClozeTestStyleModel, UrlParametersModel } from 'gast-onset-ng2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';
import { OnsetExamResultDto } from '../../shared/dtos/onset-exam-result-dto';
import { ConnectorAuthService } from '../../shared/services/common/connector-auth.service';
import { IdasService } from '../../shared/services/idas/idas.service';

@Component({
  selector: 'app-idas-onset',
  templateUrl: './idas-onset.component.html',
  styleUrls: ['./idas-onset.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, ClozeTestComponent]
})
export class IdasOnsetComponent implements OnInit {

  private readonly envConfig = inject<any>('env' as any);
  readonly #deviceService = inject(DeviceDetectorService);
  readonly #idasService = inject(IdasService);
  readonly #authService = inject(ConnectorAuthService);
  readonly #route = inject(ActivatedRoute);

  environment = this.envConfig.callback(this.envConfig.value);
  isMobile = signal(this.#deviceService.isMobile());

  gastBookingId = signal<number | null>(null);

  // TODO: replace with parameter
  startLevel = signal(2);
  endLevel = signal(5);
  variantId = signal(11);
  language = signal(1); // default DE
  lang = signal('de');

  clozeTestModel = signal<ClozeTestModel>({} as ClozeTestModel);
  clozeTestStyleModel = signal<ClozeTestStyleModel>({} as ClozeTestStyleModel);

  ngOnInit() {
    this.gastBookingId.set(null);

    this.#route.queryParams.subscribe(params => {
      if (params['lang'] === 'en') {
        this.language.set(2);
        this.lang.set('en');
      }
      this.clozeTestModel.set(this.#generateClozeTestModel());
      this.clozeTestStyleModel.set(this.#generateClozeTestStyle());
    });
  }

  onStartTest(_start: boolean): void {
    console.log(`test started`);
  }

  onBookingInit(gastBookingId: number): void {
    this.gastBookingId.set(gastBookingId);
    console.log(`init gastBookingId ${gastBookingId}`);
  }

  onTestHasBeenSaved(gastBookingId: number): void {
    this.gastBookingId.set(gastBookingId);
    console.log(`saving gastBookingId ${gastBookingId}`);
  }

  onClozeTestCompleted(): void {
    console.log(`test completed`);
  }

  onTestResult(test: any): void {
    // build result dto
    const onsetExamResultDto: OnsetExamResultDto = {} as OnsetExamResultDto;
    onsetExamResultDto.bookingId = this.gastBookingId() ?? 0;
    onsetExamResultDto.variantId = this.variantId();
    onsetExamResultDto.startLevel = this.startLevel();
    onsetExamResultDto.endLevel = this.endLevel();

    // retrieve token
    const token = this.#authService.onsetExamDataDto.value?.token ?? '';

    this.#idasService.postOnsetExamResult(token, onsetExamResultDto);
    console.log(`next test result ${test}`);
  }

  /* tslint:disable:max-line-length */
  #generateClozeTestModel(): ClozeTestModel {

    // const onsetServiceUrl = this.environment.onsetServiceUrl;
    // const onsetServiceUrl = 'http://gast-appr-app-2:8008/gast-service-onset/';
    const onsetServiceUrl = 'https://apprex.gast.de/gast-service-onset/';

    // TODO config
    const clozeTestModel: ClozeTestModel = {} as ClozeTestModel;
    clozeTestModel.getResultsUrl = onsetServiceUrl + 'api/score';
    clozeTestModel.postTestUrl = onsetServiceUrl + 'api/aufgabe/save';
    clozeTestModel.getTestUrl = onsetServiceUrl + 'api/aufgabe';
    clozeTestModel.getNextTestUrl = onsetServiceUrl + 'api/aufgabe/next';
    clozeTestModel.startWithBuchungId = this.gastBookingId() ?? 0;
    clozeTestModel.urlParameters = { herkunft: 'deutschland', geschlecht: 'm', geburtsdatum: '1990-01-01', variante: this.variantId(), testzentrum: 454, sprache: this.language(), tool: 1, start_level: this.startLevel(), end_level: this.endLevel() } as UrlParametersModel;
    return clozeTestModel;
  }

  #generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';

    return model;
  }
}
